import api from "./Api";

class AssistenteModulosService {
  GetAssistenteModulos(payload) {
    return api.get("/v1/AssistenteModulos/" + payload).then((response) => {
      return response.data;
    });
  }

  PostAssistenteModulos(payload) {
    return api.post("/v1/AssistenteModulos/", payload).then((response) => {
      return response.data;
    });
  }

  PutAssistenteModulos(payload) {
    return api.put("/v1/AssistenteModulos/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteAssistenteModulos(payload) {
    return api.delete("/v1/AssistenteModulos/" + payload).then((response) => {
      return response.data;
    });
  }

  GetAssistenteModulosOData(payload) {
    return api.get("/OData/AssistenteModulos" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new AssistenteModulosService();
